import { useCallback, useMemo } from 'react';

import { useGraphql } from '../graphql';
import { useLoad } from '../load';

// One of the clinician's patients and everything assigned to them, in one
// request: what the patient's pages draw under their header. data is
// undefined until the answer arrives or when it failed; error, retry and
// reload are useLoad's, reload being what a screen calls after it changed an
// assignment.
export function usePatientRecord(patientId) {
  const graphql = useGraphql();

  const read = useCallback(function() {
    return graphql({
      document: `query PatientRecord($id: ID!) {
        patient(id: $id) { id firstName lastName language connectedSince }
        patientAssignments(patientId: $id) {
          id assignedBy mine instructions createdAt open
          questionnaire { name language }
          attempts { id submittedAt reviewedAt }
        }
      }`,
      variables: { id: patientId }
    });
  }, [ graphql, patientId ]);

  const { data, error, retry, reload } = useLoad(read);

  return useMemo(function() {
    return { data, error, retry, reload };
  }, [ data, error, retry, reload ]);
}
